/**
 * 获取门店
 * @returns
 */
export function loadArShopList() {
  return {
    type: 'LOAD_AR_SHOP_LIST',
  };
}

export function loadArShopListCompletion(error, list) {
  return {
    type: 'LOAD_AR_SHOP_LIST_COMPLETION',
    error,
    list,
  };
}

export function verifyCoupon(query) {
  return {
    type: 'VERIFY_COUPON',
    query,
  };
}
export function verifyCouponCompletion(error, data) {
  return {
    type: 'VERIFY_COUPON_COMPLETION',
    error,
    data,
  };
}
export function loadRecordList(query) {
  return {
    type: 'LOAD_RECORD_LIST',
    query,
    willReload: query.willReload,
  };
}

export function loadRecordListCompletion(error, list) {
  return {
    type: 'LOAD_RECORD_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadAnalysisOrderList(query) {
  return {
    type: 'LOAD_ANALYSIS_ORDER_LIST',
    query,
    willReload: query.willReload,
  };
}

export function loadAnalysisOrderListCompletion(error, list) {
  return {
    type: 'LOAD_ANALYSIS_ORDER_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadAnalysisRecordList(query) {
  return {
    type: 'LOAD_ANALYSIS_RECORD_LIST',
    query,
    willReload: query.willReload,
  };
}

export function loadAnalysisRecordListCompletion(error, list) {
  return {
    type: 'LOAD_ANALYSIS_RECORD_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadMyPerformance() {
  return {
    type: 'LOAD_MY_PERFORMANCE',
  };
}

export function loadMyPerformanceCompletion(error, data) {
  return {
    type: 'LOAD_MY_PERFORMANCE_COMPLETION',
    error,
    data,
  };
}
